import React from "react";
import { MeOutput } from "@graphql";

export const LoggedInUserContext = React.createContext<MeOutput | undefined>(
  undefined
);
